/****************************************************
 * Module Name:  packetIssueMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Tooltip } from "@mui/material";
import { FaPen } from "react-icons/fa";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import renderCellExpand from "../common/dataGridCellExpand";
import Utility from "../../utility/utility";
import { useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import PacketHistoryModal from "../common/packetHistoryModal";
import Constants from "../../utility/constants";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import PacketRemark from "../common/packetRemark";
import LossRemark from "../common/lossRemark";
import AddPacketIssueModal from "./addPacketIssueModal";
import KapanCreationProxy from "../../utility/proxy/manager/manufacturingProxy/kapanCreationProxy";
import { MdSendToMobile } from "react-icons/md";
import AddEvaluation from "./addEvaluation";
import CommonStoneSelection from "../common/commonStoneSelection";
import PacketEvaluationProxy from "../../utility/proxy/manager/manufacturingProxy/packetEvaluationProxy";
import KapanHistoryModal from "../manufacturing/operations/kapanHistoryModal";
import PacketProxy from "../../utility/proxy/manager/manufacturingProxy/packetProxy";
import AddPackage from "./addPackage";
import AddPackageDetail from "./addPackageDetail";
import { GiPowderBag } from 'react-icons/gi'
import { RiRedPacketFill } from "react-icons/ri";
import { FaRegEye } from "react-icons/fa";
import ViewPacketPlan from "../manufacturing/operations/viewPacketPlan";
import { MdMerge } from "react-icons/md";
import ConfirmationModal from "../common/confirmationModal";
import { MdCancelScheduleSend } from "react-icons/md";
import { MdOutlineNotificationsActive } from "react-icons/md";
import PageTitle from "../common/pageTitle";
import { BsGraphDownArrow } from "react-icons/bs";
import { MdAssignmentAdd } from "react-icons/md";

const PacketIssueMaster = () => {
    const [listData, setListData] = useState([]);

    const [approveRejectListLoader, setApproveRejectListLoader] = useState(false);

    const [selectionModel, setSelectionModel] = useState([]);

    const [showPacketDetailModal, setShowPacketDetailModal] = useState(false);
    const [showReIssueModal, setShowReIssueModal] = useState(false);
    const [showAddIssueModal, setShowAddIssueModal] = useState(false);
    const [showPacketRemarkModal, setShowPacketRemarkModal] = useState(false);
    const [showPacketLossModal, setShowPacketLossModal] = useState(false);
    const [showPackageModal, setShowPackageModal] = useState(false);
    const [showPackageDetailModal, setShowPackageDetailModal] = useState(false);
    const [sourceData, setSourceData] = useState({});
    const [showPacketEvaluationModal, setShowPacketEvaluationModal] = useState(false);
    const [snackbarVariant, setSnackbarVariant] = useState("");
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [showSnackbar, setShowSnackbar] = useState(false);

    const [loadingButton, setLoadingButton] = useState(false);
    const [cancelLoader, setCancelLoader] = useState(false);
    const [notifyLoader, setNotifyLoader] = useState(false);

    const [packetId, setPacketId] = useState("");
    const [kapanId, setKapanId] = useState("");
    const [totalPacketCount, setTotalPacketCount] = useState("");
    const [showKapanDetailModal, setShowKapanDetailModal] = useState(false);
    const [isKapanStatusNew, setIsKapanStatusNew] = useState(false);
    const [isPacketStatusNew, setIsPacketStatusNew] = useState(false);
    const [packetCarats, setPacketCarats] = useState(0);

    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [showCancelConfirmationModal, setShowCancelConfirmationModal] = useState(false);
    const [confirmModalMessage, setConfirmModalMessage] = useState("");
    const [confirmModalTitle, setConfirmModalTitle] = useState("");
    const [submitLoader, setSubmitLoader] = useState(false);
    const [columnNames, setColumnNames] = useState([]);

    const [totalPacket, setTotalPacket] = useState(0);
    const [totalCarats, setTotalCarats] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [avgPrice, setAvgPrice] = useState(0);

    // eslint-disable-next-line
    const [local_Permission, setLocal_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MANUFACTURING_OPERATION_PACKETISSUE
        )
    );
    // eslint-disable-next-line
    const [packetRemark_Permission, setPacketRemark_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MANUFACTURING_PACKET_REMARK
        )
    );
    // eslint-disable-next-line
    const [lossRemark_Permission, setLossRemark_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.LOSSREMARK
        )
    );
    // eslint-disable-next-line
    const [addEvaluation_Permission, setaddEvaluation_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MANUFACTURING_ADD_EVALUATION
        )
    );

    // eslint-disable-next-line
    const [packaging_Permission, setPackaging_Permission] = useState(
        Constants.USER_PERMISSION.filter(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.MANUFACTURING_PACKAGING
        )
    );

    const viewPacketPlanPermission = Constants.USER_PERMISSION.filter(iPermission =>
        iPermission.permissionid === Constants.PERMISSIONS.MANUFACTURING_PACKET_PLANNING);
    const [viewPacketPlanModal, setViewPacketPlanModal] = useState(false);

    useEffect(() => {
        PageTitle("MANUFACTURING_OPERATION_PACKETISSUE");
        handleSearch();
    }, []);

    const handleSearch = () => {
        setApproveRejectListLoader(true);
        PacketProxy.GetAllMyPacketByDepartment((response) => {
            if (response) {
                const uniqueFilterValues = {
                    user: Utility.getDistinctOptions(response, "username"),
                    department: Utility.getDistinctOptions(response, "department_name"),
                    process: Utility.getDistinctOptions(response, "processname"),
                    nextprocess: Utility.getDistinctOptions(response, "nextprocessname"),
                };
                const combinedFilterValues = {
                    user: uniqueFilterValues.user.map(value => {
                        const matchingItem = response.find(item => item.username === value);
                        return matchingItem ? `${matchingItem.userid} | ${value}` : value;
                    }),
                    department: uniqueFilterValues.department.map(value => {
                        const matchingItem = response.find(item => item.department_name === value);
                        return matchingItem ? `${matchingItem.department_id} | ${value}` : value;
                    }),
                    processname: uniqueFilterValues.process.map(value => {
                        const matchingItem = response.find(item => item.processname === value);
                        return matchingItem ? `${matchingItem.processid} | ${value}` : value;
                    }),
                    nextprocessname: uniqueFilterValues.nextprocess.map(value => {
                        const matchingItem = response.find(item => item.nextprocessname === value);
                        return matchingItem ? `${matchingItem.nextprocessid} | ${value}` : value;
                    }),
                };

                const updatedResponse = response.map(iData => ({
                    ...iData,
                    embededkey: iData.kapanid + "_" + iData.packetid
                }));

                const filterMap = generateFilterMap(Array.isArray(response) ? response : [response]);

                const allFilters = {
                    ...filterMap,
                    ...combinedFilterValues,
                }

                prepareColumns(allFilters);
                setListData(updatedResponse);
                setSelectionModel([])
                setApproveRejectListLoader(false);
                getSummaryReport(response);
            } else {
                setApproveRejectListLoader(false);
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        });
    };

    const generateFilterMap = (responseData) => {
        const filterMap = {};

        // Process issued department head
        const department = responseData.map((dept) => ({
            id: dept.next_department_head_id,
            username: dept.nextdepartmenthead,
        }));

        filterMap.nextdepartmenthead = [
            ...new Set(
                department.map((group) => `${group.id} | ${group.username}`)
            ),
        ];

        // Process issued department 
        const departmentGroup = responseData.map((dept) => ({
            id: dept.next_department_id,
            username: dept.nextdepartmentname,
        }));

        filterMap.nextdepartmentname = [
            ...new Set(
                departmentGroup.map((group) => `${group.id} | ${group.username}`)
            ),
        ];

        // Process Process 
        const process = responseData.map((dept) => ({
            id: dept.processid,
            name: dept.processname,
        }));

        filterMap.processname = [
            ...new Set(
                process.map((group) => `${group.id} | ${group.name}`)
            ),
        ];

        // Process Next Process 
        const nextprocess = responseData.map((dept) => ({
            id: dept.nextprocessid,
            name: dept.nextprocessname,
        }));

        filterMap.nextprocessname = [
            ...new Set(
                nextprocess.map((group) => `${group.id} | ${group.name}`)
            ),
        ];

        return filterMap;
    };

    const prepareColumns = (uniqueFilterValues) => {
        const columnNames = columnsWithoutPermission.map(woPermissionColumn => {
            let guids = [];

            // Determine which GUIDs (permissions) should be added based on the column field
            switch (woPermissionColumn.field) {
                case "packetid":
                    guids = [
                        Constants.COLUMN_PERMISSION.MFG_PACKET_CARATS,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_PRICE,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_CREATEDAT,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_UPDATEDAT,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_USER,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_DEPARTMENT,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_NEXT_DEPARTMENT_HEAD,
                        Constants.COLUMN_PERMISSION.MFG_PACKET_NEXT_DEPARTMENT,
                    ];
                    break;
                default:
                    guids = [];
            }

            // Retrieve valid permission columns
            return fetchColumnDataFromGuid(guids, woPermissionColumn, columnsWithPermission, uniqueFilterValues);

        }).flat(); // Flatten the array

        // Update state with the prepared columns
        setColumnNames(columnNames);
    };

    const fetchColumnDataFromGuid = (guids, currentColumn, columnsWithPermission, uniqueFilterValues) => {
        const permissionColumns = guids
            .map(id => Constants.USER_COLUMN_PERMISSION.find(permission => permission === id)) // Match permissions
            .filter(Boolean) // Remove undefined values (invalid permissions)
            .map(guid => {
                const columnData = columnsWithPermission[guid]; // Get column details

                // If the columnData is missing or an empty object, skip adding it
                if (!columnData || Object.keys(columnData).length === 0) {
                    return null;
                }

                if (columnData.field === "nextdepartmenthead") {
                    columnData.type = "singleSelect";
                    columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.nextdepartmenthead : [];
                    columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'next_department_head_id', 'nextdepartmenthead');
                }
                if (columnData.field === "nextdepartmentname") {
                    columnData.type = "singleSelect";
                    columnData.valueOptions = uniqueFilterValues ? uniqueFilterValues.nextdepartmentname : [];
                    columnData.filterOperators = Utility.customFilters(uniqueFilterValues, columnData.field, 'next_department_id', 'nextdepartmentname');
                }
                else {

                    // Retrieve unique filter values for the column, defaulting to an empty array
                    const filterData = uniqueFilterValues[columnData.field] || [];

                    return {
                        ...columnData,  // Copy all existing column properties
                        valueOptions: filterData,  // Assign filter values
                    };
                }

                return columnData;
            })
            .filter(Boolean); // Remove any null values from the list

        if (currentColumn.field === "processname") {
            currentColumn.type = "singleSelect";
            currentColumn.valueOptions = uniqueFilterValues ? uniqueFilterValues.process : [];
            currentColumn.filterOperators = Utility.customFilters(uniqueFilterValues, currentColumn.field, 'processid', 'processname');
        }
        if (currentColumn.field === "nextprocessname") {
            currentColumn.type = "singleSelect";
            currentColumn.valueOptions = uniqueFilterValues ? uniqueFilterValues.nextprocess : [];
            currentColumn.filterOperators = Utility.customFilters(uniqueFilterValues, currentColumn.field, 'nextprocessid', 'nextprocessname');
        }
        // Modify the original column before adding it to the list
        const modifiedColumn = {
            ...currentColumn,  // Retain original column properties
            valueOptions: uniqueFilterValues[currentColumn.field] || [], // Assign filter values
        };

        // Return an array with the modified column and any valid permission columns
        return [modifiedColumn, ...permissionColumns];
    };

    const getSummaryReport = (data) => {
        if (!Array.isArray(data)) return;
        let totalPackets = data.length;
        let carats = 0;
        let price = 0;
        data.forEach((item) => {
            carats += item.carats;
            price += item.carats * item.price;
        });
        let avgprice = price / carats;

        setTotalPacket(totalPackets);
        setTotalPrice(price);
        setTotalCarats(carats);
        setAvgPrice(avgprice);
    }

    const handleValidation = (data) => {
        //TODO do validation if needed here
        return true;
    };

    const handleCancelIssue = () => {
        setShowCancelConfirmationModal(true);
        setConfirmModalMessage("Are you sure you want to cancel issue for the selected packets?");
        setConfirmModalTitle("Cancel Issue");
    }

    const handlePacketDetailModal = (params, kapanid) => {
        setPacketId(params);
        setKapanId(kapanid);
        setShowPacketDetailModal(true);
    };

    const handleRowSelection = (params) => {
        if (params.row.packetid === "0") {
            return false;
        } else {
            return true
        }
    }

    const disableIssue = () => {
        if (selectionModel.length === 0) return true;
        return !selectionModel.every(iData => {
            const matchingRow = listData.find(iRow => iRow.embededkey === iData);
            return matchingRow && matchingRow.next_department_head_id === null && matchingRow.next_department_id === null;
        });
    };

    const disableCancelOrNotify = () => {
        if (selectionModel.length === 0) return true;
        return selectionModel.some(iData => {
            const matchingRow = listData.find(iRow => iRow.embededkey === iData);
            return matchingRow && matchingRow.next_department_head_id === null && matchingRow.next_department_id === null;
        });
    };


    const setSnackbarState = (show, message, variant) => {
        setShowSnackbar(show);
        setSnackbarMessage(message);
        setSnackbarVariant(variant);
    };

    const handlePacketSelection = (packetIds) => {
        let lstKapanId_PacketId = [];
        packetIds.forEach(iData => {
            if (iData.includes("_")) {
                lstKapanId_PacketId.push(iData);
            } else {
                let lstRecords = listData.filter(iRow => iRow.packetid === iData);
                if (lstRecords.length > 0)
                    lstRecords.forEach(iRow => lstKapanId_PacketId.push(iRow.embededkey));
            }
        });
        setSelectionModel([...selectionModel, ...lstKapanId_PacketId])
    };

    const addPackage = (packageData) => {
        setLoadingButton(true);

        if (packageData && packageData.totalpackets) {
            setKapanId(packageData.kapanid);
            setTotalPacketCount(packageData.totalpackets);
            setShowPackageModal(false);
            setShowPackageDetailModal(true);
            setLoadingButton(false);
        } else {
            setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            setLoadingButton(false);
        }

    };

    const hideModal = () => {
        setShowKapanDetailModal(false);
        setShowPackageDetailModal(false);
        setShowPackageModal(false);
    };

    const addPackageDetail = (packageData) => {
        setLoadingButton(true);
        //Creating new issue, and once issue is created on call refresh the list of current issue
        PacketProxy.AddSubPackets(packageData, kapanId, packetId, (response) => {
            if (response) {
                handleSearch();
                setLoadingButton(false);
                hideModal();
                setSnackbarState(true, "Packet added or updated successfully ", "success");
            } else {
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setLoadingButton(false);
            }
        });
    };

    const addIssue = (IssueData) => {
        setLoadingButton(true)
        // Creating new issue, and once issue is created on call refresh the list of current issue
        PacketProxy.AddPacketIssue(IssueData, (response) => {
            if (response) {
                handleSearch()
                setLoadingButton(false)
                setShowReIssueModal(false)
                setShowAddIssueModal(false)
                setSnackbarState(true, response.errorMessage, response.status);
            } else {
                setShowReIssueModal(false)
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setLoadingButton(false)
            }
        });
    };

    const addPacketEvaluation = (packageData) => {
        setLoadingButton(true)
        //Creating new issue, and once issue is created on call refresh the list of current issue
        PacketEvaluationProxy.AddPackageEvaluation(packageData, (response) => {
            if (response) {
                handleSearch()
                setLoadingButton(false)
                setShowPacketEvaluationModal(false)
                setSnackbarState(true, "Packet evaluation added successfully", "success");
            } else {
                setShowPacketEvaluationModal(false)
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setLoadingButton(false)
            }
        });
    };

    const addPacketRemark = (data) => {
        setLoadingButton(true)
        // Creating new issue, and once issue is created on call refresh the list of current issue
        KapanCreationProxy.AddPacketRemarkCategory(data, (response) => {
            if (response) {
                handleSearch()
                setLoadingButton(false)
                setShowReIssueModal(false)
                setShowAddIssueModal(false)
                setShowPacketRemarkModal(false)
                setSnackbarState(true, "Packet remark added successfully", "success");
            } else {
                setShowPacketRemarkModal(false)
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setLoadingButton(false)
            }
        });
    };

    const addPacketLossRemark = (data) => {
        setLoadingButton(true)
        // Creating new issue, and once issue is created on call refresh the list of current issue
        KapanCreationProxy.AddPacketLossRemarkCategory(data, (response) => {
            if (response) {
                handleSearch()
                setLoadingButton(false)
                setShowReIssueModal(false)
                setShowAddIssueModal(false)
                setShowPacketRemarkModal(false)
                setShowPacketLossModal(false)
                setSnackbarState(true, "Packet loss remark added successfully", "success");
            } else {
                setShowPacketLossModal(false)
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
                setLoadingButton(false)
            }
        });
    };

    const getpacketsDetail = (params) => {

        setLoadingButton(true);

        PacketProxy.GetFurtherPacketDetail(params.row.kapanid, params.row.packetid, (response) => {
            setLoadingButton(false);

            if (response) {
                setSourceData(response);
                setShowPackageDetailModal(true)
                setKapanId(params.row.kapanid)
                setPacketId(params.row.packetid)
                setIsKapanStatusNew(params.row.kapanstatus === "NEW")
                setIsPacketStatusNew(params.row.status === "NEW")
                setPacketCarats(params.row.carats);
            } else {
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        });

    };

    const handleKapanDetailModal = (params) => {
        setKapanId(params);
        setShowKapanDetailModal(true);
    };

    const prepareData = () => {
        return {
            kapanid: parseInt(sourceData.kapanid),
            packetid: sourceData.packetid,
        };
    };

    const handleMergePacket = () => {
        let data = prepareData();
        setSubmitLoader(true);
        PacketProxy.MergeToPacketZero(data, (response) => {
            if (response) {
                setSubmitLoader(false);
                setShowConfirmationModal(false);
                setSnackbarState(true, response.errorMessage, response.status);
                handleSearch();
            } else {
                setSubmitLoader(false);
                setShowConfirmationModal(false);
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        })
    }

    const handleCancelIssuePacket = () => {
        setCancelLoader(true);
        let data = [];
        selectionModel.forEach(iData => {
            let matchingRow = listData.find(iRow => iRow.embededkey === iData);
            let dataObj = {
                packetid: matchingRow.packetid,
                kapanid: matchingRow.kapanid,
            };
            data.push(dataObj);
        });
        PacketProxy.CancelPacketIssue(data, (response) => {
            if (response) {
                setCancelLoader(false);
                setShowCancelConfirmationModal(false);
                setSnackbarState(true, response.errorMessage, response.status);
                handleSearch();
            } else {
                setCancelLoader(false);
                setShowCancelConfirmationModal(false);
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        })
    };

    const handleNotifyUser = () => {
        setNotifyLoader(true);
        let data = [];
        selectionModel.forEach(iData => {
            let matchingRow = listData.find(iRow => iRow.embededkey === iData);
            let dataObj = {
                packetid: matchingRow.packetid,
                kapanid: matchingRow.kapanid,
            };
            data.push(dataObj);
        });
        PacketProxy.NotifyUser(data, (response) => {
            if (response) {
                setNotifyLoader(false);
                setSnackbarState(true, "Notification Sent Successfully", "success");
            } else {
                setNotifyLoader(false);
                setSnackbarState(true, Constants.APiFailErrorMessage, "error");
            }
        });
    }

    const columnsWithPermission = {
        "0effedb5-9d19-4964-b11f-e722ffd19f2c": {
            field: "carats",
            headerName: "CARATS",
            headerAlign: "center",
            align: "center",
            minWidth: 100,
            flex: 1,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => params.value,
        },
        "da017870-3fdd-4560-9522-6cc693c6565d": {
            field: "price",
            headerName: "PPC",
            headerAlign: "center",
            align: "right",
            width: 70,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.price)
        },
        "43e79a8b-ec36-4c61-9d73-a7968fea5b3b": {
            field: "createdat",
            headerName: "CREATED AT",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            flex: 1,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        "49fb0c84-687f-4940-88f3-ce7312c97b1a": {
            field: "updatedat",
            headerName: "UPDATED AT",
            headerAlign: "center",
            align: "center",
            minWidth: 180,
            flex: 1,
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
        },
        "366b9c15-7b22-4ec5-99ad-ec3f1e17c3cd": {
            field: "user",
            headerName: "USER",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            type: "singleSelect",
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.userid + " | " + params.row.username,
            renderCell: renderCellExpand
        },
        "f1b9e3fa-fa0b-4439-9ead-a7d3c0d6d63f": {
            field: "department",
            headerName: "DEPARTMENT",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            type: "singleSelect",
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.department_id + " | " + params.row.department_name,
            renderCell: renderCellExpand
        },
        "5b8746c7-e52a-4488-b65f-095b4cef0a1a": {
            field: "nextdepartmenthead",
            headerName: "ISSUED DEPARTMENT HEAD",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => (
                params.row.next_department_head_id ?
                    <Box sx={{ minHeight: "auto", mt: 1 }}>
                        <Chip
                            avatar={<Avatar>{params.row.next_department_head_id}</Avatar>}
                            label={params.row.nextdepartmenthead}
                            sx={{ margin: "0px 10px 10px 0px" }}
                        />
                    </Box>
                    : '-'
            ),
            disableExport: true,
        },
        "b9ca1ec9-ab70-47ee-8c02-9e6db0358e9a": {
            field: "nextdepartmentname",
            headerName: "ISSUED DEPARTMENT NAME",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => (
                params.row.next_department_id ?
                    <Box sx={{ minHeight: "auto", mt: 1 }}>
                        <Chip
                            avatar={<Avatar>{params.row.next_department_id}</Avatar>}
                            label={params.row.nextdepartmentname}
                            sx={{ margin: "0px 10px 10px 0px" }}
                        />
                    </Box> : '-'
            ),
            disableExport: true,
        },

    };

    const columnsWithoutPermission = [
        {
            field: "kapanid",
            headerName: "KAPANID",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 80,
            renderCell: (params) => (Utility.NeedToShowKapanDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handleKapanDetailModal(params.value)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "packetid",
            headerName: "PACKETID",
            headerAlign: "center",
            align: "center",
            width: 80,
            renderCell: (params) => (Utility.NeedToShowPacketDetailModal()) ?
                <Button
                    sx={{
                        textDecorationLine: "underline",
                        color: 'black'
                    }}
                    onClick={() => handlePacketDetailModal(params.value, params.row.kapanid)}
                >
                    {params.value}
                </Button>
                :
                <div>{params.value}</div>,
        },
        {
            field: "processname",
            headerName: "CURRENT PROCESS",
            headerAlign: "center",
            align: "center",
            width: 250,
            renderCell: (params) => {
                if (params.row.processid == null || params.row.processname == null)
                    return '-';
                return (
                    <Box sx={{ minHeight: "auto", mt: 1 }}>
                        <Chip
                            avatar={<Avatar>{params.row.processid}</Avatar>}
                            label={params.row.processname}
                            sx={{ margin: "0px 10px 10px 0px" }}
                        />
                    </Box>
                )
            },
            disableExport: true,
        },
        {
            field: "nextprocessname",
            headerName: "NEXT PROCESS",
            headerAlign: "center",
            align: "center",
            width: 250,
            renderCell: (params) => {
                if (params.row.nextprocessid == null || params.row.nextprocessname == null)
                    return '-';
                return (
                    <Box sx={{ minHeight: "auto", mt: 1 }}>
                        <Chip
                            avatar={<Avatar>{params.row.nextprocessid}</Avatar>}
                            label={params.row.nextprocessname}
                            sx={{ margin: "0px 10px 10px 0px" }}
                        />
                    </Box>
                )
            },
            disableExport: true,
        },
        {
            field: "issue",
            headerName: "RE-ISSUE",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => (
                (Utility.isAddAllowed(local_Permission) || Utility.isUpdateAllowed(local_Permission)) ?
                    (params.row.next_department_head_id !== null || params.row.next_department_id !== null) ?
                        <Button
                            startIcon={<MdSendToMobile />}
                            sx={{ width: 150 }}
                            color='success'
                            variant="contained"
                            onClick={() => {
                                setShowReIssueModal(true)
                                setSourceData([params.row])
                                setLoadingButton(false)
                            }}
                        >
                            Re-Issue
                        </Button> : '-' : '-'
            ),
            disableExport: true,
        },
        {
            field: "package",
            headerName: "PACKETS",
            headerAlign: "center",
            align: "center",
            minWidth: 200,
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                const isPendingDepartment = row.next_department_head_id === null || row.next_department_id === null;
                const isInProgress = row.status === 'IN_PROGRESS';
                const isNew = row.status === 'NEW';
                const isKapanStatusNew = row.kapanstatus === "NEW";

                const handleUpdatePackage = (e) => {
                    e.stopPropagation();
                    getpacketsDetail(params);
                };

                const handleCreatePackage = (e) => {
                    e.stopPropagation();
                    setShowPackageModal(true);
                    setKapanId(row.id);
                    setPacketId(row.packetid);
                    setIsKapanStatusNew(isKapanStatusNew);
                    setIsPacketStatusNew(isNew);
                    setSourceData(row);
                    setPacketCarats(row.carats);
                };

                if (row.packetid !== "0" && isPendingDepartment && isInProgress && Utility.isUpdateAllowed(packaging_Permission)) {
                    return (
                        <Button
                            startIcon={<GiPowderBag />}
                            sx={{ width: 200 }}
                            color="success"
                            variant="contained"
                            onClick={handleUpdatePackage}
                        >
                            Update Package
                        </Button>
                    );
                }

                if (row.packetid !== "0" && isPendingDepartment && isNew && Utility.isAddAllowed(packaging_Permission)) {
                    return (
                        <Button
                            startIcon={<RiRedPacketFill />}
                            sx={{ width: 200 }}
                            variant="contained"
                            onClick={handleCreatePackage}
                        >
                            Create Package
                        </Button>
                    );
                }

                return '-';
            },
            disableExport: true,
        },
        {
            field: "mergepacket",
            headerName: "MERGE PACKET 0",
            headerAlign: "center",
            align: "center",
            minWidth: 200,
            flex: 1,
            renderCell: (params) => {
                const isPendingDepartment = params.row.next_department_head_id === null || params.row.next_department_id === null;
                if (params.row.packetid !== "0" && isPendingDepartment && params.row.kapanstatus === "PACKAGED" && (Utility.isAddAllowed(packaging_Permission) || Utility.isUpdateAllowed(packaging_Permission))) {
                    return (
                        <Button
                            startIcon={<MdMerge size={'20px'} />}
                            sx={{ width: 200 }}
                            color='info'
                            variant="contained"
                            onClick={() => {
                                setShowConfirmationModal(true);
                                setConfirmModalMessage("Are you sure you want to merge this packet into Packet 0?");
                                setConfirmModalTitle("Merge Packet");
                                setSourceData(params.row);
                            }
                            }
                        >
                            Merge Packet 0
                        </Button>
                    );
                }
                return '-';
            },
            disableExport: true,
        },
        {
            field: "viewplan",
            headerName: "VIEW PLAN",
            headerAlign: "center",
            align: "center",
            width: 180,
            renderCell: (params) => (params.row.packetid !== "0" && Utility.isReadAllowed(viewPacketPlanPermission) ? (
                <Button
                    startIcon={<FaRegEye />}
                    color="success"
                    variant="contained"
                    onClick={() => {
                        setPacketId(params.row.packetid);
                        setKapanId(params.row.kapanid);
                        setViewPacketPlanModal(true);
                    }}
                >
                    View Plan
                </Button>
            ) : null),
            disableExport: true
        },
        {
            field: "packetremark",
            headerName: "PACKET REMARK",
            headerAlign: "center",
            align: "center",
            minWidth: 200,
            flex: 1,
            renderCell: (params) => (
                (Utility.isAddAllowed(packetRemark_Permission) || Utility.isUpdateAllowed(packetRemark_Permission)) ?
                    <Button
                        startIcon={<FaPen size={'15px'} />}
                        sx={{ width: 190 }}
                        color='info'
                        variant="contained"
                        onClick={() => {
                            setPacketId(params.row.packetid);
                            setKapanId(params.row.kapanid);
                            setSourceData(params.row)
                            setShowPacketRemarkModal(true)
                            setLoadingButton(false)
                        }
                        }
                    >
                        Packet Remark
                    </Button> : ''
            ),
            disableExport: true,
        },
        {
            field: "lossremark",
            headerName: "LOSS REMARK",
            headerAlign: "center",
            align: "center",
            minWidth: 150,
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                const isIssued = row.next_department_head_id === null || row.next_department_id === null;
                if ((row.packetid !== "0" && (Utility.isAddAllowed(lossRemark_Permission) || Utility.isUpdateAllowed(lossRemark_Permission))) && isIssued) {
                    return (
                        <Button
                            startIcon={<BsGraphDownArrow size={'15px'} />}
                            sx={{ width: 130 }}
                            color='info'
                            variant="contained"
                            onClick={() => {
                                setPacketId(params.row.packetid);
                                setKapanId(params.row.kapanid);
                                setSourceData(params.row)
                                setShowPacketLossModal(true)
                                setLoadingButton(false)
                            }}
                        >
                            Add Loss
                        </Button>
                    );
                }
                return '-';
            },
            disableExport: true,
        },
        {
            field: "evaluation",
            headerName: "ADD EVALUATION",
            headerAlign: "center",
            align: "center",
            minWidth: 170,
            flex: 1,
            renderCell: (params) => {
                const { row } = params;
                const isIssued = row.next_department_head_id === null || row.next_department_id === null;
                if ((row.packetid !== "0" && (Utility.isAddAllowed(addEvaluation_Permission) || Utility.isUpdateAllowed(addEvaluation_Permission))) && isIssued) {
                    return (
                        <Button
                            startIcon={<MdAssignmentAdd size={'18px'} />}
                            sx={{ width: 160 }}
                            color='info'
                            variant="contained"
                            onClick={() => {
                                setPacketId(params.row.packetid);
                                setKapanId(params.row.kapanid);
                                setSourceData(params.row)
                                setShowPacketEvaluationModal(true)
                                setLoadingButton(false)
                            }
                            }
                        >
                            Evaluation
                        </Button>
                    );
                }
                return '-';
            },
            disableExport: true,
        },
    ];

    const colFilter1 = (Utility.isAddAllowed(local_Permission) || Utility.isUpdateAllowed(local_Permission)) ? columnNames :
        columnNames.filter(col => col.field !== "issue");
    const colFilter2 = (Utility.isAddAllowed(packetRemark_Permission) || Utility.isUpdateAllowed(packetRemark_Permission)) ? colFilter1 :
        colFilter1.filter(col => col.field !== "packetremark");
    const colFilter3 = (Utility.isAddAllowed(lossRemark_Permission) || Utility.isUpdateAllowed(lossRemark_Permission)) ? colFilter2 :
        colFilter2.filter(col => col.field !== "lossremark");
    const colFilter4 = (Utility.isReadAllowed(viewPacketPlanPermission)) ? colFilter3 :
        colFilter3.filter(col => col.field !== "viewplan");
    const colFilter5 = (Utility.isAddAllowed(packaging_Permission) || Utility.isUpdateAllowed(packaging_Permission)) ? colFilter4 :
        colFilter4.filter(col => col.field !== "mergepacket");
    const columns = (Utility.isAddAllowed(addEvaluation_Permission) || Utility.isUpdateAllowed(addEvaluation_Permission)) ? colFilter5 :
        colFilter5.filter(col => col.field !== "evaluation");

    return (
        <div>

            <TabMenuSnackbar
                show={showSnackbar}
                message={snackbarMessage}
                variant={snackbarVariant}
                autoHide={Constants.SnackBarCloseTimer}
                title={snackbarVariant === "success" ? "Success" :
                    snackbarVariant === "error" ? "Failed" : "Warning"}
                handleClose={() => setShowSnackbar(false)}
            />
            {showKapanDetailModal ? (
                <KapanHistoryModal
                    show={showKapanDetailModal}
                    kapanId={kapanId}
                    close={() => setShowKapanDetailModal(false)}
                />
            ) : null}
            {showPacketDetailModal ? (
                <PacketHistoryModal
                    show={showPacketDetailModal}
                    packetId={packetId}
                    kapanId={kapanId}
                    close={() => setShowPacketDetailModal(false)}
                />
            ) : null}
            {showReIssueModal || showAddIssueModal ? (
                <AddPacketIssueModal
                    Show={true}
                    handleClose={() => {
                        setShowReIssueModal(false)
                        setShowAddIssueModal(false)
                    }}
                    handleSave={addIssue}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                    sourceData={sourceData}
                />
            ) : null}
            {showPacketRemarkModal ? (
                <PacketRemark
                    Show={true}
                    handleClose={() => setShowPacketRemarkModal(false)}
                    handleSave={addPacketRemark}
                    packetId={packetId}
                    kapanId={kapanId}
                    sourceData={sourceData}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                />
            ) : (
                <Box />
            )}
            {showPacketLossModal ? (
                <LossRemark
                    Show={true}
                    handleClose={() => setShowPacketLossModal(false)}
                    handleSave={addPacketLossRemark}
                    packetId={packetId}
                    kapanId={kapanId}
                    sourceData={sourceData}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                />
            ) : (
                <Box />
            )}

            {showPackageModal ? (
                <AddPackage
                    Show={true}
                    handleClose={hideModal}
                    handleSave={addPackage}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                    sourceData={sourceData}
                    kapanToPacket={false}
                />
            ) : (
                <Box />
            )}

            {showPackageDetailModal ? (
                <AddPackageDetail
                    Show={true}
                    handleClose={hideModal}
                    handleSave={addPackageDetail}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                    sourceData={sourceData}
                    fromKapan={false}
                    kapanId={kapanId}
                    isKapanStatusNew={isKapanStatusNew}
                    isPacketStatusNew={isPacketStatusNew}
                    fromPacketId={packetId}
                    addPacketPermission={Utility.isAddAllowed(packaging_Permission)}
                    totalPacketCount={totalPacketCount}
                    kapanPcs={null}
                    maxCarats={packetCarats}
                />
            ) : (
                <Box />
            )}

            {showPacketEvaluationModal ? (
                <AddEvaluation
                    Show={true}
                    handleClose={() => setShowPacketEvaluationModal(false)}
                    handleSave={addPacketEvaluation}
                    handleValidation={handleValidation}
                    loading={loadingButton}
                    sourceData={sourceData}
                />
            ) : (
                <Box />
            )}

            {viewPacketPlanModal ? (
                <ViewPacketPlan
                    kapanid={kapanId}
                    packetid={packetId}
                    handleClose={() => setViewPacketPlanModal(false)}
                />
            ) : null}

            {showConfirmationModal ? (
                <ConfirmationModal
                    show={showConfirmationModal}
                    setShow={setShowConfirmationModal}
                    handleSave={handleMergePacket}
                    modalTitle={confirmModalTitle}
                    modalMessage={confirmModalMessage}
                    loading={submitLoader}
                />
            ) : null}

            {showCancelConfirmationModal ? (
                <ConfirmationModal
                    show={showCancelConfirmationModal}
                    setShow={setShowCancelConfirmationModal}
                    handleSave={handleCancelIssuePacket}
                    modalTitle={confirmModalTitle}
                    modalMessage={confirmModalMessage}
                    loading={cancelLoader}
                />
            ) : null}

            <Box
                sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    width: "100%",
                    position: "relative",
                    "& .MuiTablePagination-selectLabel": {
                        marginTop: "15px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                        marginTop: "15px",
                    },
                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                        fontWeight: Constants.defaultFontWeight,
                    },
                    "& .css-cc8tf1": {
                        fontWeight: Constants.defaultFontWeight,
                    },
                    height: "77vh",
                }}
            >
                <DataGridPro
                    disableRowSelectionOnClick={true}
                    getRowHeight={() => "auto"}
                    sx={{
                        '& .MuiDataGrid-columnHeader': {
                            color: '#fff',
                            backgroundColor: 'grey',
                        },
                        "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                            py: "4px",
                        },
                        "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                            py: "12px",
                        },
                        "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                            py: "18px",
                        },
                        fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                    }}
                    density="compact"
                    loading={approveRejectListLoader}
                    slots={{ toolbar: GridToolbar }}
                    rows={listData}
                    columns={columns}
                    isRowSelectable={handleRowSelection}
                    getRowId={(row) => row.embededkey}
                    checkboxSelection={true}
                    onRowSelectionModelChange={(newSelectionModel) => {
                        const selectedIDs = new Set(newSelectionModel);
                        const selectedRowData = listData.filter((row) => selectedIDs.has(row.embededkey.toString()))
                        setSelectionModel(newSelectionModel);
                        setSourceData(selectedRowData)
                    }}
                    rowSelectionModel={selectionModel}
                    initialState={{
                        columns: {
                            columnVisibilityModel: {
                                // Hide columns id, the other columns will remain visible
                            },
                        },
                        sorting: {
                            sortModel: [{ field: "packetid", sort: "asc" }],
                        },
                        pagination: {
                            paginationModel: Constants.pageSize,
                        },
                    }}
                    pageSizeOptions={Constants.pageSizeOptions}
                    pagination
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
                <Box sx={{
                    position: "absolute",
                    left: "0.4rem",
                    top: "1px"
                }}>
                    <CommonStoneSelection title={"Enter Multiple 'KapanId_PacketId'"} handleSelection={handlePacketSelection} buttonDisabled={listData.length === 0} />
                </Box>
                <Box
                    sx={{
                        position: "absolute",
                        top: "11px",
                        left: "590px",
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '36rem',
                        color: "black",
                        fontWeight: 'normal',
                        fontSize: Constants.defaultTableFontSize
                    }}
                ><p style={{ margin: 0 }}>
                        <span>Total Packet:</span> <b>{totalPacket}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                        <span>Total Carats: </span> <b>{totalCarats.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                        <span>Total Price: </span> <b>{totalPrice.toFixed(2)}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                        <span>Avg Price: </span> <b>{isNaN(avgPrice) ? "0.00" : avgPrice.toFixed(2)}</b></p>
                </Box>
                <Box
                    style={{
                        position: "absolute",
                        top: 5,
                        right: "270px",
                        display: "flex",
                        flexWrap: "nowrap",
                    }}
                >
                    {approveRejectListLoader ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <Tooltip title="Reload List">
                            <RefreshOutlinedIcon
                                onClick={() => handleSearch()}
                                color="primary"
                                fontSize="medium"
                                sx={{ cursor: "pointer" }}
                            />
                        </Tooltip>
                    )}
                    {Utility.isUpdateAllowed(local_Permission) ? (
                        <Tooltip title="Notify">
                            <Button
                                component="label"
                                variant="outlined"
                                size="small"
                                sx={{ ml: "5px" }}
                                loading={notifyLoader}
                                startIcon={<MdOutlineNotificationsActive size={20} />}
                                disabled={disableCancelOrNotify()}
                                onClick={() => handleNotifyUser()}
                            >
                                Notify
                            </Button>
                        </Tooltip>
                    ) : null}
                    {Utility.isUpdateAllowed(local_Permission) ? (
                        <Tooltip title="Cancel">
                            <Button
                                component="label"
                                variant="outlined"
                                size="small"
                                sx={{ ml: "5px" }}
                                loading={cancelLoader}
                                startIcon={<MdCancelScheduleSend size={20} />}
                                disabled={disableCancelOrNotify()}
                                onClick={() => handleCancelIssue()}
                            >
                                Cancel
                            </Button>
                        </Tooltip>
                    ) : null}
                    {Utility.isUpdateAllowed(local_Permission) ? (
                        <Tooltip title="Issue">
                            <Button
                                component="label"
                                variant="contained"
                                size="small"
                                sx={{ ml: "5px" }}
                                startIcon={<ThumbUpAltIcon size="large" />}
                                disabled={disableIssue()}
                                onClick={() => setShowAddIssueModal(true)}
                            >
                                Issue
                            </Button>
                        </Tooltip>
                    ) : null}

                </Box>
            </Box>
        </div>
    );
};

export default PacketIssueMaster;
